import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

export default function MembershipButton({
  as: Component,
  className,
  children,
  ...restProps
}) {
  return (
    <Component
      className={mergeClasses(
        'cursor-pointer rounded-full border border-solid border-[#640CD4] bg-[#640CD4] px-4 py-3 text-sm font-bold text-white',
        className
      )}
      type={Component === 'button' ? 'button' : undefined}
      {...restProps}
    >
      {children}
    </Component>
  );
}

MembershipButton.propTypes = {
  as: PropTypes.oneOf(['button', 'a']),
  className: PropTypes.string,
  children: PropTypes.string.isRequired
};

MembershipButton.defaultProps = {
  as: 'button',
  className: ''
};
